<template>
  <div>
    <h3 class="ui dividing header">Основная информация</h3>
    <div class="inline fields">
      <div class="five wide field">
        <div class="ui right pointing large label">
          РАБОЧАЯ ПРОГРАММА
        </div>
        <input type="text" placeholder="Дисциплина" v-model="main_info.discipline" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
        <div class="ui right pointing large label">
          Направление подготовки
        </div>
        <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
        <div class="ui right pointing large label">
          Специальность
        </div>
        <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
      </div>
      <div class="four wide field">
        <div class="ui right pointing large label">
          Квалификация выпускника
        </div>
        <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
      </div>
    </div>
    <div class="inline fields">
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
        <div class="ui right pointing large label">
          Профиль
        </div>
        <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
      </div>
      <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
        <div class="ui right pointing large label">
          Специализация
        </div>
        <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
      </div>
      <div class="two wide field">
        <div class="ui right pointing large label">
          Год набора
        </div>
        <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
      </div>
      <div class="three wide field">
        <div class="ui right pointing large label">
          Форма обучения
        </div>
        <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
      </div>
    </div>
    <div class="ui equal width form">
      <div class="inline fields">
        <div class="three wide field">
          <div class="ui right pointing large label">
            Курс
          </div>
          <input type="text" placeholder="Курс" v-model="main_info.course" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Семестр
          </div>
          <input type="text" placeholder="Семестр" v-model="main_info.period" disabled="true">
        </div>
        <div class="three wide field" v-if="main_info.credit.length">
          <div class="ui right pointing large label">
            Зачет
          </div>
          <input type="text" placeholder="Зачет" v-model="main_info.credit" disabled="true">
        </div>
        <div class="three wide field" v-if="main_info.credit_mark.length">
          <div class="ui right pointing large label">
            Зачет с оценкой
          </div>
          <input type="text" placeholder="Зачет" v-model="main_info.credit_mark" disabled="true">
        </div>
        <div class="three wide field" v-if="main_info.exam.length">
          <div class="ui right pointing large label">
            Экзамен
          </div>
          <input type="text" placeholder="Экзамен" v-model="main_info.exam" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Трудоемкость
          </div>
          <input type="text" placeholder="Трудоемкость" v-model="main_info.load.hour" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            ЗЕТ
          </div>
          <input type="text" placeholder="ЗЕТ" v-model="main_info.load.zet" disabled="true">
        </div>
      </div>
      <div class="inline fields">
        <div class="four wide field">
          <div class="ui right pointing large label">
            И.О.Фамилия
          </div>
          <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Должность
          </div>
          <input type="text" placeholder="Должность" v-model="main_info.creator.position">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Ученая степень
          </div>
          <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title">
        </div>
      </div>
    </div>
    <table class="ui red celled table">
      <thead>
      <tr class="active">
        <th>Семестр</th>
        <th>Нагрузка</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for = "load in TotalLoad">
        <td width="70%" >{{ load.key }}</td>
        <td>
          <div class="ui list" v-for = "type in load.value">
            <div class="item">{{type.load}} - {{type.value}}</div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="two fields">
      <div class="six wide field">
        <label>Выпускающая кафедра</label>
        <select class="ui fluid search selection dropdown"
                name="grad_dep"
                v-model="main_info.grad_dep">
          <option value="">Выпускающая кафедра</option>
          <option v-for="option in select_options.departments" :value="option.name" :key="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="six wide field">
        <label>Заведующий выпускающей кафедры</label>
        <div class="ui input">
          <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor">
        </div>
      </div>
    </div>
    <div class="three fields">
      <div class="five wide field">
        <label>Факультет</label>
        <div class="ui input">
          <input type="text" placeholder="Факультет" v-model="main_info.facility">
        </div>
      </div>
      <div class="five wide field">
        <label>Обеспечивающая кафедра</label>
        <div class="ui input">
          <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department">
        </div>
      </div>
      <div class="five wide field">
        <label>
          Заведующий кафедрой
        </label>
        <div class="ui input">
          <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager">
        </div>
      </div>
    </div>
    <div class="two fields">
      <div class="four wide field">
        <label>Дата заседания кафедры</label>
        <div class="ui input">
          <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date">
        </div>
      </div>
      <div class="two wide field">
        <label>Протокол №</label>
        <div class="ui input">
          <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num">
        </div>
      </div>
    </div>
    <div><textarea rows="2" v-model="main_info.basis"></textarea></div>
    <div class="two fields">
      <div class="four wide field">
        <label>Дата утверждения приказа</label>
        <div class="ui input">
          <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date">
        </div>
      </div>
      <div class="two wide field">
        <label>№ Приказа</label>
        <div class="ui input">
          <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "main-info",
  props: {
    main_info: {
      require:true
    },
    TotalLoad:{
      require:true
    },
    select_options: {
      require:true
    },
  },

  computed: {
    initial: function () {
      let initial = ""
      initial += this.main_info.creator.fio.split(' ')[1][0];
      initial += "."
      initial += this.main_info.creator.fio.split(' ')[2][0];
      initial += "."
      initial += this.main_info.creator.fio.split(' ')[0];

      return initial;
    },
    provisor: function (){
      this.select_options.departments.forEach(head => {
        if (head.name === this.main_info.grad_dep){
          this.main_info.provisor = head.head;
        }
      })
      return this.main_info.provisor
    },
  },
}
</script>

<style scoped>

</style>